import { render, staticRenderFns } from "./DataChartGoodClass.vue?vue&type=template&id=bdf60d9c&scoped=true&"
import script from "./DataChartGoodClass.vue?vue&type=script&lang=ts&"
export * from "./DataChartGoodClass.vue?vue&type=script&lang=ts&"
import style0 from "./DataChartGoodClass.vue?vue&type=style&index=0&id=bdf60d9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf60d9c",
  null
  
)

export default component.exports